<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialogs.quickmenuDialog"
      max-width="600"
      persistent
      scrollable
    >
      <v-card style="padding: 10px">
        <v-card-title
          class="headline lighten-2"
          primary-title
        >
          クイックメニュー編集
        </v-card-title>
        <v-card-actions>
          <v-btn
            block
            color="secondary"
            large
            @click="createConfirm"
          >
            <v-icon left>
              mdi-pencil-plus
            </v-icon>
            新しいメニューを作成
          </v-btn>
        </v-card-actions>
        <Bubble
          class="mt-2"
          text="要素はドラッグ＆ドロップで並び替えができます"
        />
        <v-divider />
        <v-card-text>
          <draggable v-model="EditorMenuList">
            <v-list-item
              v-for="(item, index) in EditorMenuList"
              :key="item.order"
            >
              <v-list-item-content>
                <v-list-item-title v-text="item.label" />
              </v-list-item-content>

              <v-list-item-action>
                <v-btn
                  color="primary"
                  icon
                  @click="item.visible=!item.visible"
                >
                  <v-icon v-if="item.visible">
                    mdi-eye-outline
                  </v-icon>
                  <v-icon v-else>
                    mdi-eye-off-outline
                  </v-icon>
                </v-btn>
              </v-list-item-action>

              <v-list-item-action
                v-if="!item.primaryItem"
                style="margin-left: 20px"
              >
                <v-btn
                  class="ma-2"
                  color="primary"
                  outlined
                  @click="editConfirm(item, index)"
                >
                  編集
                </v-btn>
              </v-list-item-action>
              <v-list-item-action v-if="!item.primaryItem">
                <v-btn
                  class="ma-2"
                  color="red"
                  outlined
                  @click="deleteConfirm(item)"
                >
                  削除
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </draggable>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            elevation="0"
            style="border-radius: 0px"
            tile
            @click="clearItem"
          >
            キャンセル
          </v-btn>
          <v-btn
            color="secondary"
            elevation="0"
            style="border-radius: 0px"
            tile
            @click="saveList"
          >
            保存
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-dialog
        v-model="deleteDialog"
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">
            削除確認
          </v-card-title>
          <v-card-text v-if="deleteItemData!=null">
            「{{ deleteItemData.label }}」　を削除してもよろしいですか？
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="green darken-1"
              text
              @click="deleteDialog = false"
            >
              キャンセル
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              @click="deleteItem(deleteItemData)"
            >
              削除
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="editDialog"
        max-width="600px"
        persistent
      >
        <v-card>
          <v-card-title>
            <span class="headline">クイックメニュー編集</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              メニューのラベル
              <small>※ボタンに表示するテキスト</small>
              <v-text-field
                v-if="editItemData!=null"
                v-model="editItemData.label"
                :maxlength="inputLength.label"
                outlined
                single-line
              />
              入力するテキスト
              <small>※ボタンを押した時に実際に入力されるテキスト</small>
              <v-text-field
                v-if="editItemData!=null"
                v-model="editItemData.inputValue"
                :maxlength="inputLength.text"
                outlined
                single-line
              />
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="blue darken-1"
              text
              @click="editDialog = false"
            >
              閉じる
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editItem(editItemData)"
            >
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-dialog>

    <v-dialog
      v-model="createDialog"
      max-width="600px"
      persistent
    >
      <v-card>
        <v-card-title>
          <span class="headline">クイックメニュー作成</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            メニューのラベル
            <small>※ボタンに表示するテキスト</small>
            <v-text-field
              v-if="editItemData!=null"
              v-model="editItemData.label"
              :maxlength="inputLength.label"
              outlined
              single-line
            />
            入力するテキスト
            <small>※ボタンを押した時に実際に入力されるテキスト</small>
            <v-text-field
              v-if="editItemData!=null"
              v-model="editItemData.inputValue"
              :maxlength="inputLength.text"
              outlined
              single-line
            />
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="createDialog = false"
          >
            閉じる
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="createItem()"
          >
            保存
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import clonedeep from 'lodash.clonedeep'
import draggable from "vuedraggable";
import Bubble from "@/component/Bubble";
import config from "@/const"

export default {
  components: {
    draggable,
    Bubble
  },
  props: ["dialogs"],
  data() {
    return {
      inputLength: config.INPUT_LENGTH.quickMenu,
      deleteDialog: false,
      deleteItemData: null,
      createDialog: false,
      editDialog: false,
      editItemData: null,
      editItemIndex: null,
      EditorMenuList: clonedeep(this.$store.state.EditorMenuModule.EditorMenu)
    }
  },


  methods: {
    clearItem() {
      this.EditorMenuList = clonedeep(this.$store.state.EditorMenuModule.EditorMenu)
      this.dialogs.quickmenuDialog = false
    },
    saveList() {
      this.$store.dispatch("EditorMenuModule/updateParams", {newData: this.EditorMenuList}).then(
          value => {
            this.dialogs.quickmenuDialog = false
          }
      ).catch(reason => {
        alert("データ更新に失敗しました。再度お試しください")
      })

    },
    editConfirm(editItemData, index) {
      this.editItemData = clonedeep(editItemData);
      this.editItemIndex = index;
      this.editDialog = true
    },
    createConfirm() {
      this.editItemData = {
        id: null,
        label: "",
        type: 999,
        inputValue: "",
        primaryItem: false,
        visible: true,
        icon: null,
        orderIndex: 0,
        usertoken: null,
        modifiedTimestamp: null
      };
      this.createDialog = true
    },
    createItem() {
      this.createDialog = false;
      this.EditorMenuList.push(this.editItemData);
    },
    editItem(editItemData) {
      this.editDialog = false
      const found = this.EditorMenuList[this.editItemIndex];
      found.label = editItemData.label;
      found.inputValue = editItemData.inputValue;
    },
    // 削除確認ダイアログ表示を追加
    deleteConfirm(deleteItemData) {
      this.deleteItemData = deleteItemData;
      this.deleteDialog = true;
    },
    // 削除実行
    deleteItem(deleteItemData) {
      this.EditorMenuList = this.EditorMenuList.filter(function (item) {
        return item != deleteItemData;
      })
      this.deleteDialog = false;
    },
  }
}
</script>

<style>

</style>
